import isEqual from 'lodash.isequal';

export const assignLevelToElements = (elements) => {
    let updatedElements = [...elements]
    let topLevelStr = updatedElements.find(ele => !ele.assign)
    if(topLevelStr) {
        topLevelStr.level = Number(0)
    }
    updatedElements.forEach(element => {
        let prevElement = updatedElements.find(ele => ele.define === element.assign);
        if(prevElement && !element.hasOwnProperty('level')) {
            element.level = Number(prevElement.level)  + 1  
        }
    })
    return updatedElements
}

const extractChildrenOptions = (optionsObj, option, index, currentElement, elements) => {
    if(currentElement.level - 1 === index ) {
        if(option.children){
            let parentOfCurrentElement = option.children.filter(element => element.label === currentElement.assign );
            if(parentOfCurrentElement.length > 0) {
                parentOfCurrentElement = parentOfCurrentElement.map(opt => {
                    return {...opt, label: opt.value, define: opt.label, parentValue: option.value}
                })
                optionsObj["level" + index] = (optionsObj["level" + index] || []).concat(parentOfCurrentElement);
            }
        }  
       
    } else {
        if(option.children && option.children.length > 0 ) {
            // option.children.filter(opt => opt.value === values["level" + index])
            option.children = option.children.map(opt => {
                return {...opt, label: opt.value, define: opt.label, parentValue: option.value}
            })
            optionsObj["level" + index] = (optionsObj["level" + index] || []).concat(option.children);
            option.children.forEach(child => {
                extractChildrenOptions(optionsObj, child, index + 1, currentElement, elements)
            })
        }
    }
    return optionsObj;
}

export const extractOptionsFromTree = (treeData, elements, currentElement) => {
    let options = {}
    let topLevelParent = elements.find(element => !element.assign)
    options["level0"] = treeData.filter(data => data.label === topLevelParent.define).map(data => {
        return {...data, label: data.value, define: data.label, parentValue: ''}
    })
    if(options.level0.length > 0) {
        options["level0"].forEach(option => {
            extractChildrenOptions(options, option, 1, currentElement, elements)
        })
    }
    return options
}

export const getTopLevelInFormData = (formData) => {
    let requiredLevel = "";
    let levelKeys = Object.keys(formData).filter(key => key.includes("level"));
    if(levelKeys.length === 0) {
        requiredLevel = "top";
    } else {
        levelKeys.reverse();
        requiredLevel = levelKeys[0]
    }
    return requiredLevel

}

export const getNodeId = (treeData) => {
    let reqId;
    let highestKey = Math.max(...treeData.map(o => o.level === 'level0' ? o.id : Number(o.id.split("-")[1])))
    reqId = highestKey >= 0  ? highestKey + 1 : 0;
    return reqId
}

export const addCurrentNodeToParent = (currentNode, values, key, selectedNode) => {
    
    currentNode.children.forEach((node, index) => {
        if(node.level === key && node.value === values[key]) {
            let reqKey = "level" + (Number(key.slice(-1)) + 1)
            if(selectedNode.value) {
                node.children = node.children.map(child => {
                    let childObj = {...child}
                    if(child.id === selectedNode.id){
                        childObj.label = values.elementLabel
                        childObj.value = values.elementName
                    }
                    return childObj
                })
                return
            } else {
                let id = node.id + "-" + node.children.length
                node.children.push({label: values.elementLabel, value: values.elementName, children: [], level: reqKey, id: id})
            }
        } else {
            addCurrentNodeToParent(node, values, key, selectedNode)
        }
    })
}

export const removeNodeFromTree = (nodes, selectedNode) => {    
    nodes.forEach(node => {
        let reqKey = "level" + (Number(selectedNode.level.slice(-1)) - 1)
        if(node.level === reqKey) {
            node.children = node.children.filter(child => child.value !== selectedNode.value)
        } else {
            removeNodeFromTree(node.children || [], selectedNode)
        }
    })
}

const extractValues = (treeData, currentElement, orgValues) => {
    treeData.forEach(node => {
        if(node.label === currentElement) {
            orgValues.push(node.value)
        } else {
            if(node.children) {
                extractValues(node.children, currentElement, orgValues)
            }
        }
    })
    return orgValues
}

export const getOrgValuesFromTree = (treeData, unit) => {
    let orgValues = [];
    treeData.forEach(node => {
        if(node.label === unit) {
            orgValues.push(node.value)
        } else {
            if(node.children) {
                extractValues(node.children, unit, orgValues)
            }
        }
    })
    return orgValues;
}

export const getTopParent = (node, unit) => {
    let found = false;
    let currentNode = node.children;
    for(let i=0; i < currentNode.length; i++) {
        if(currentNode[i].value === unit.value){
            found = true
        }
        if(found){
            break
        } else {
           found = getTopParent(currentNode[i], unit)
        }
    }
    return found
}

export const getNodeParent = (treeData, unit) => {
    let reqParent = {}
    for(let i=0; i < treeData.length; i++) {
        let parentFound = getTopParent(treeData[i], unit)
        if(parentFound) {
            reqParent = treeData[i]
            break;
        }
    }
    return reqParent
}

export const checkDuplicatesAtLevel = (nodes, level, formData, result={exists: false}) => {
    // Create a Set to track unique values at the current level
    if(result.exists) {
        return true
    }

    for(let i=0; i < nodes.length; i++) {
        let node = nodes[i];
        if(node.level == level) {
            if(node.value === formData[level]) {
                // let elementExists = node.children.find(child => child.value === formData.elementName.trim() || child.value.toLowerCase() === formData.elementName.toLowerCase())
                let elementExists = node.children.find(child => {
                        return isEqual(child, formData)
            })
                    // child.value === formData.elementName.trim() || child.value.toLowerCase() === formData.elementName.toLowerCase())
                
                if(elementExists) {
                    result.exists = true
                    result.existedElement = elementExists
                }
            }
        } 
        else {
            checkDuplicatesAtLevel(node.children, level, formData, result)
        }
        if(result.exists) {
            break;
        }
    }  
    return result;
  };

  export function findNodeById(array, id, parent={}) {
    for (const obj of array) {
      if (obj.id == id) {
        if(parent.id){
            return {...obj, parent: parent}
        } else {
            return obj
        }
      } else if (obj.children && obj.children.length > 0) {
        const result = findNodeById(obj.children, id, obj);
        if (result) {
          return {...result };
        }
      }
    }
    return null;
  }

export const getFormElements = () => {
    let elements = [];
    if(localStorage.getItem("formElements")){
        elements = JSON.parse(localStorage.getItem("formElements"))
    }
    return elements;
}

export const storeFormElements = (elements) => {
    if(!elements){
        return
    }
    localStorage.setItem("formElements", JSON.stringify(elements))
}